/**
 * Kemana_Checkout
 *
 * @see README.md
 *
 */

/*global define*/
define(
    'Kemana_Checkout/js/model/shipping-rates-validator',[
        'jquery',
        'Magento_Checkout/js/model/shipping-rates-validation-rules',
        'mage/translate',
        'uiRegistry',
        'Magento_Checkout/js/model/address-converter',
        'Magento_Checkout/js/action/select-shipping-address',
        'mageUtils'
    ],
    function ($, shippingRatesValidationRules, $t, uiRegistry, addressConverter, selectShippingAddress, utils) {
        'use strict';
        var postcodeElementName = 'postcode';
        var postcodeElement = null;
        var districtIdElement = null;
        var districtIdElementName = 'district_id';
        var cityIdElement = null;
        var cityIdElementName = 'city_id';

        return function(shippingRatesValidator){

            shippingRatesValidator.validateDelay = 1000;

            shippingRatesValidator.initFields = function(formPath) {
                var self = this,
                    elements = shippingRatesValidationRules.getObservableFields();

                if ($.inArray(postcodeElementName, elements) === -1) {
                    // Add postcode field to observables if not exist for zip code validation support
                    elements.push(postcodeElementName);
                }

                if ($.inArray(districtIdElementName, elements) === -1) {
                    // district id
                    elements.push(districtIdElementName);
                }

                if ($.inArray(cityIdElementName, elements) === -1) {
                    // city id
                    elements.push(cityIdElementName);
                }

                $.each(elements, function (index, field) {
                    uiRegistry.async(formPath + '.' + field)(self.doElementBinding.bind(self));
                });
            };


            shippingRatesValidator.doElementBinding = function (element, force, delay) {
                var observableFields = shippingRatesValidationRules.getObservableFields();

                if (element && (observableFields.indexOf(element.index) !== -1 || force)) {
                    if (element.index !== postcodeElementName) {
                        this.bindHandler(element, delay);
                    }
                }

                if (element.index === postcodeElementName) {
                    this.bindHandler(element, delay);
                    postcodeElement = element;
                }

                if (element.index === districtIdElementName) {
                    this.bindHandler(element, delay);
                    districtIdElement = element;
                }

                if (element.index === cityIdElementName) {
                    this.bindHandler(element, delay);
                    cityIdElement = element;
                }
            };

            shippingRatesValidator.validateFields = function () {
                var addressFrm = addressConverter.formDataProviderToFlatData(
                    this.collectObservedData(),
                    'shippingAddress'
                ),
                address,
                addressFlat;

                if (utils.isEmpty(addressFrm.custom_attributes.city_id)) {
                    $('select[name="custom_attributes[city_id]"]').blur(function () {
                        if (this.value === "") {
                            cityIdElement.error($t(cityIdElement.label + ' is required.'));
                        }
                    });
                    return;
                } else {
                    cityIdElement.error(null);
                }

                if (utils.isEmpty(addressFrm.custom_attributes.district_id)) {
                    $('select[name="custom_attributes[district_id]"]').blur(function () {
                        if (this.value === "") {
                            districtIdElement.error($t(districtIdElement.label + ' is required.'));
                        }
                    });
                    return;
                } else {
                    districtIdElement.error(null);
                }
                $('input[name="telephone"]').focusin(function () {
                    $(this).parent().find('.field-error').css("display", "none");
                });
                $('input[name="postcode"]').focusin(function () {
                    $(this).parent().find('.field-error').css("display", "none");
                });
                $('input[name="telephone"]').focusout(function () {
                    $(this).parent().find('.field-error').css("display", "block");
                });
                $('input[name="postcode"]').focusout(function () {
                    $(this).parent().find('.field-error').css("display", "block");
                });

                if (this.validateAddressData(addressFrm)) {
                    addressFlat = uiRegistry.get('checkoutProvider').shippingAddress;
                    addressFlat.city = addressFrm.custom_attributes.city_id + '/' + addressFrm.custom_attributes.district_id;
                    address = addressConverter.formAddressDataToQuoteAddress(addressFlat);
                    selectShippingAddress(address);
                }
            };

            return shippingRatesValidator;
        }
    }
);

